<template>
  <div class="main">

    <div class="right">
      <!-- <TopCard ref="TopCardRef"
               text="排行榜"
               :showBack="true" /> -->
      <img src="@/assets/leftcontroller/返回.png"
           style="    position: absolute;
    left: 123px;
    top: 32px;
    width: 42px;
    z-index: 9999;
    height: 42px;"
           @click="back"
           alt="">
      <TopCard1 ref="TopCardRef1"
                text="我的试卷"
                :isTabs="true"
                :tabList="tabList"
                :showBack="false" />

      <div class="subject_wrap">
        <SubjectCard ref="SubjectCardRef"
                     @initList="getInfo" />
        <div class="type_id">
          <el-select v-model="a_type"
                     placeholder="请选择"
                     clearable
                     @change="getInfo()">
            <el-option v-for="item in typeList"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div>
        <div v-if="tableData.length>0"
             style="background-color: #ffffff;height: 683rem;">
          <div class="list_wrap">
            <div class="img_list">
              <div style="margin-top: 15rem; position: relative;  ">
                <img src="@/assets/rank/2.png"
                     alt=""
                     class="img" />
                <div v-if="top3[1]"
                     class="head3">
                  <div style="display: flex;  gap: 20rem;  display: flex;
    justify-content: center;
    margin-bottom: 12rem;
    align-items: center;">
                    <div class="head_img2">
                      <img :src="top3[0].avatar"
                           v-if="top3[0].avatar"
                           alt="">
                      <img src="@/assets/personalCenter/头像.png"
                           v-else
                           alt="">
                    </div>

                    <div class="top3">
                      <div class="name">{{ top3[1]?top3[1].truename:"" }}</div>

                      <div class="school"
                           v-show="a_type==3">{{ top3[1]?top3[1].school_name:"" }}</div>
                    </div>
                  </div>
                  <div class="bottom">
                    <div class="num">{{type==1?'做题数量':'5套卷以上综合得分率'}} </div>
                    <div class="num1"
                         v-if="top3[1]">{{ top3[1]&&type==1?top3[1].do_num+"题" :top3[1].rate+"%" }}</div>
                  </div>
                </div>
                <div v-else
                     class="text3">暂无人上榜</div>

              </div>
              <div style="  position: relative;">
                <img src="@/assets/rank/1.png"
                     alt=""
                     class="img" />
                <div v-if="top3[0]"
                     class="head1">
                  <div style="display: flex;  gap: 20rem;  display: flex;
                margin-bottom: 12rem;
    justify-content: center;
    align-items: center;">
                    <div class="head_img2">
                      <img :src="top3[0].avatar"
                           v-if="top3[0].avatar"
                           alt="">
                      <img src="@/assets/personalCenter/头像.png"
                           v-else
                           alt="">
                    </div>
                    <div class="top1">
                      <div class="name">{{ top3[0]?top3[0].truename:"" }}</div>

                      <div class="school"
                           v-show="a_type==3">{{ top3[0]?top3[0].school_name:"" }}</div>
                    </div>
                  </div>
                  <div class="bottom1">
                    <div class="num">{{type==1?'做题数量':'5套卷以上综合得分率'}} </div>
                    <div class="num1"
                         v-if="top3[0]">{{ type==1?top3[0].do_num+"题" :top3[0].rate+"%" }}</div>
                  </div>
                </div>
                <div v-else
                     class="text1">暂无人上榜</div>
              </div>
              <div style="margin-top: 25rem;position: relative; ">
                <img src="@/assets/rank/3.png"
                     alt=""
                     class="img" />
                <div v-if="top3[2]"
                     class="head2">
                  <div style="display: flex; gap: 20rem;   display: flex;
                margin-bottom: 12rem;
    justify-content: center;
    align-items: center;">
                    <div class="head_img2">
                      <img :src="top3[0].avatar"
                           v-if="top3[0].avatar"
                           alt="">
                      <img src="@/assets/personalCenter/头像.png"
                           v-else
                           alt="">
                    </div>
                    <div class="top2">
                      <div class="name">{{ top3[2]?top3[2].truename:"" }}</div>

                      <div class="school"
                           v-show="a_type==3">{{ top3[2]?top3[2].school_name:"" }}</div>
                    </div>
                  </div>
                  <div class="bottom2">
                    <div class="num">{{type==1?'做题数量':'5套卷以上综合得分率'}}</div>
                    <div class="num1"
                         v-if="top3[2]">{{ type==1?top3[2].do_num+"题" :top3[2].rate+"%" }}</div>
                  </div>
                </div>
                <div v-else
                     class="text2">暂无人上榜</div>

              </div>
            </div>
            <el-table :data="tableData"
                      style="margin-top: 15rem;"
                      :header-cell-style="headerStyle"
                      :row-class-name="rowClassName"
                      v-if="tableData.length>0&&myList!={}">
              <el-table-column prop="ranking"
                               align="center"
                               label="排名">
                <template slot-scope="{row}">

                  <img src="@/assets/rank/排行榜1.png"
                       v-if="row.ranking == 1"
                       alt="">
                  <img src="@/assets/rank/排行榜2.png"
                       v-if="row.ranking == 2"
                       alt="">
                  <img src="@/assets/rank/排行榜3.png"
                       v-if="row.ranking == 3"
                       alt="">
                  <div v-if="row.ranking!=1&&row.ranking!=2&&row.ranking!=3">{{ row.ranking == 0 ? '-' : row.ranking }}</div>
                </template>
              </el-table-column>
              <el-table-column prop="truename"
                               align="center"
                               label="用户">
                <template slot-scope="{row}">
                  <div style="display:flex;margin-left: 200rem;gap:20rem; ">
                    <div class="head_img">
                      <img :src="row.avatar"
                           v-if="row.avatar"
                           alt="">
                      <img src="@/assets/personalCenter/头像.png"
                           v-else
                           alt="">
                    </div>
                    <div style="display: flex;flex-direction: column;align-items: flex-start;justify-content: center;">
                      <div> {{row.truename}}</div>
                      <div v-show="a_type==3"> {{row.school_name}}</div>
                    </div>
                  </div>

                </template>
              </el-table-column>

              <el-table-column prop="do_num"
                               align="center"
                               v-if="type==1"
                               label="成绩（做题数量）">
                <template slot-scope="{row}">
                  {{row.do_num}}题
                </template>
              </el-table-column>
              <el-table-column prop="rate"
                               align="center"
                               v-if="type==2"
                               label="成绩（5套卷以上综合得分率）">
                <template slot-scope="{row}">
                  {{row.rate?row.rate+"%":0}}
                </template>
              </el-table-column>
              <template #append>
                <tr class="el-table__row"
                    style="background-color: #E3F2FD;">
                  <td class="el-table_1_column_1 is-center "
                      width="601">
                    <img src="@/assets/rank/我的排名.png"
                         style="    position: absolute;
    top: 0rem;
    left: 1rem;"
                         alt="">
                    <div class="cell">
                      <img src="@/assets/rank/排行榜1.png"
                           v-if="myList.ranking == 1"
                           alt="">
                      <img src="@/assets/rank/排行榜2.png"
                           v-if="myList.ranking == 2"
                           alt="">
                      <img src="@/assets/rank/排行榜3.png"
                           v-if="myList.ranking == 3"
                           alt="">
                      <div v-if="myList.ranking!=1&&myList.ranking!=2&&myList.ranking!=3">{{ myList.ranking == 0 ? '-' : myList.ranking }}</div>
                    </div>
                  </td>

                  <td class="el-table_1_column_2 is-center "
                      width="601">
                    <div class="cell">

                      <div style="display:flex;margin-left: 200rem;gap:20rem;margin-bottom: 3rem;">
                        <div class="head_img">
                          <img :src="myList.avatar"
                               v-if="myList.avatar"
                               alt="">
                          <img src="@/assets/personalCenter/头像.png"
                               v-else
                               alt="">
                        </div>
                        <div style="display: flex;flex-direction: column;align-items: flex-start; ">
                          <div> {{myList.truename}}</div>
                          <div v-show="a_type==3"> {{myList.school_name}}</div>
                        </div>
                      </div>
                      <div v-if="myList.ranking == 0&&type==2&&myList.do_num<5"
                           style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                    alt="">做够5套卷试试，冲刺排行榜</div>

                      <div v-if="myList.ranking == 0&&type==1"
                           style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                    alt="">马上开始做题，保你榜上有名</div>
                      <div v-if="myList.ranking == 1"
                           style="color:#666"><img src="@/assets/rank/冠军.png"
                                                   alt=""> 冠军是起点，未来更闪耀
                      </div>
                      <div v-if="myList.rate == '0.00'&&type==2&&myList.do_num>=5"
                           style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                    alt=""> 再努努力，保你榜上有名
                      </div>
                      <div v-if="myList.rate != '0.00'&&myList.ranking!=1&&myList.ranking!=0"
                           style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                    alt=""> 再提高{{Number(myList.j_num || 0).toFixed(3)}}%的得分率，就有机会超越上一名
                      </div>
                      <div v-if="type==1&&myList.ranking!=1&&myList.ranking!=0"
                           style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                    alt=""> 距离上一名仅差{{myList.j_num}}题，再努力一点点就有机会超越
                      </div>

                    </div>
                  </td>

                  <td class="el-table__cell  is-center"
                      width="601">
                    <div class="cell">
                      {{ type == 1 ? (myList.do_num || 0) + '题' : (myList.rate || 0) + '%' }}
                    </div>
                  </td>

                </tr>
              </template>

            </el-table>
          </div>
        </div>
        <div class="list_wrap1"
             v-else>
          <div><img src="@/assets/rank/nodata.png"
                    alt=""
                    class="img" /></div>
          <div class="text2">暂无排行榜，加油做题冲榜~</div>
          <el-table :data="tableData"
                    style="height: 0px;"
                    :row-class-name="rowClassName"
          >

            <template #append>
              <tr class="el-table__row"
                  style="background-color: #E3F2FD;">
                <td class="el-table_1_column_1 is-center "
                    width="601">
                  <img src="@/assets/rank/我的排名.png"
                       style="    position: absolute;
    top: 0rem;
    left: 1rem;"
                       alt="">
                  <div class="cell">
                    <img src="@/assets/rank/排行榜1.png"
                         v-if="myList.ranking == 1"
                         alt="">
                    <img src="@/assets/rank/排行榜2.png"
                         v-if="myList.ranking == 2"
                         alt="">
                    <img src="@/assets/rank/排行榜3.png"
                         v-if="myList.ranking == 3"
                         alt="">
                    <div v-if="myList.ranking!=1&&myList.ranking!=2&&myList.ranking!=3">{{ myList.ranking == 0 ? '-' : myList.ranking }}</div>
                  </div>
                </td>

                <td class="el-table_1_column_2 is-center "
                    width="601">
                  <div class="cell">

                    <div style="display:flex;margin-left: 200rem;gap:20rem;">
                      <div class="head_img">
                        <img :src="myList.avatar"
                             v-if="myList.avatar"
                             alt="">
                        <img src="@/assets/personalCenter/头像.png"
                             v-else
                             alt="">
                      </div>
                      <div style="display: flex;flex-direction: column;align-items: flex-start;">
                        <div> {{myList.truename}}</div>
                        <div v-show="a_type==3"> {{myList.school_name}}</div>
                      </div>
                    </div>
                    <div v-if="myList.ranking == 0&&type==2&&myList.do_num<5"
                         style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                  alt="">做够5套卷试试，冲刺排行榜</div>

                    <div v-if="myList.ranking == 0&&type==1"
                         style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                  alt="">马上开始做题，保你榜上有名</div>
                    <div v-if="myList.ranking == 1"
                         style="color:#666"><img src="@/assets/rank/冠军.png"
                                                 alt=""> 冠军是起点，未来更闪耀
                    </div>
                    <div v-if="myList.rate == '0.00'&&type==2&&myList.do_num>=5"
                         style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                  alt=""> 再努努力，保你榜上有名
                    </div>
                    <div v-if="myList.rate != '0.00'&&myList.ranking!=1&&myList.ranking!=0&&type==2"
                         style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                  alt=""> 再提高{{myList.j_num}}%的得分率，就有机会超越上一名
                    </div>
                    <div v-if="type==1&&myList.ranking!=1&&myList.ranking!=0"
                         style="color:#666"> <img src="@/assets/rank/加油1.png"
                                                  alt=""> 距离上一名仅差{{myList.j_num}}题，再努力一点点就有机会超越
                    </div>

                  </div>
                </td>

                <td class="el-table__cell  is-center"
                    width="601">
                  <div class="cell">
                    {{ type == 1 ? (myList.do_num || 0) + '题' : (myList.rate || 0) + '%' }}
                  </div>
                </td>

              </tr>
            </template>

          </el-table>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
import LeftController from '@/views/components/left_controller.vue'
import TopCard from '@/views/components/top_card/index.vue'
import TopCard1 from '@/views/components/top_card/index.vue'
import { getStudentSubject, getRankList } from '@/api/subject.js'

import SubjectCard from '@/views/components/subject_card/indexCp.vue'
import { mapState, mapMutations } from 'vuex'
export default {
  data () {
    return {
      tableData: [],
      top3: [],
      item: [],
      type: 1,
      idx: 0,
      index: 0,
      a_type: 1,
      subjectId: 7,
      myList: [],
      typeList: [

        { label: '全国排名', value: 1 },
        { label: '本省排名', value: 2 },
        { label: '本校排名', value: 3 },
      ],
      tabList: [
        { label: '做题数量', value: 1 },
        { label: '得分率', value: 2 },
      ],
    }
  },
  components: {
    LeftController, TopCard, TopCard1, SubjectCard
  },
  mounted () {
    this.$removePaperInfo()
    this.getSubjectList()


  },
  computed: {
    ...mapState(['subjectList', 'knowledageData', 'pointData']),
    list () {
      return this.subjectList.filter(item => item.subject_id != 13)
    }
  },
  methods: {
    ...mapMutations(['SET_SUBJECT', 'SET_KNOWLEDGE', 'SET_POINT']),
    rowClassName ({ row }) {
      // 当 id 等于 1 时返回类名
      console.log("888798", row.id == this.myList.id)
      return row.id == this.myList.id ? 'highlight-row' : '';
    },
    back(){
      this.$router.go(-1)
    },
    getSummaries ({ columns }) {
      // 要统计的那一条
      const target = this.myList ? this.myList : {};   // 自己决定取哪条
      const sums = [];

      columns.forEach((column, index) => {

        if (column.property === 'ranking') {
          sums[index] = target.ranking == 0 ? '-' : target.ranking
        } else if (column.property === 'truename') {
          if (this.a_type == 3) {

            sums[index] = `${target.truename ?? ''} ${target.school_name ?? ''}`;

          } else {
            sums[index] = `${target.truename ?? ''}`;
          }
        }
        else if (column.property === 'do_num' && this.type === 1) {
          sums[index] = Number(target.do_num ?? 0) + "题";
        } else if (column.property === 'rate' && this.type === 2) {
          sums[index] = (Number(target.rate ?? 0)) + '%';
        } else {
          sums[index] = '';   // 其余列不显示
        }
      });

      return sums;
    },
    async getSubjectList () {

      const { data } = await getStudentSubject()
      this.SET_SUBJECT(data.list)
      this.subjectId = this.subjectList[0].subject_id
    },
    checkStatus (index, item) {
      this.type = item.value
      this.getInfo()
    },
    check (id, index) {
      this.index = index ? index : 0
    },
    headerStyle() {
      return {
        background:  "#F5F5F5 "
      }
    },
    refresh () {
      this.$refs.SubjectCardRef.refresh()
    },
    async getInfo (id, subject_name,) {


      const { data } = await getRankList({
        type: this.type,
        a_type: this.a_type,
        subject_id: Number(id) || this.$refs.SubjectCardRef.subjectId,

      })
      this.tableData = data.list
      this.myList = data.my
      const possibleKeys = ['do_j_num', 'rate'];
      const pickCount = item => {
        const key = this.type == 2 ? possibleKeys[1] : possibleKeys[0];
        return Number.isFinite(item[key]) ? item[key] : 0;
      };

      const top3 = data.list
          .slice()
          .sort((a, b) => pickCount(b) - pickCount(a))
          .slice(0, 3);
      console.log('top3', top3)
      this.top3 = top3
    },

  }
}
</script>

<style lang="scss" scoped>
::v-deep .tab{
  display: none !important;
}
::v-deep .top {
  height: 56rem;
  margin-bottom: 14rem;
}
::v-deep .subject_search .subject div {
  height: 48rem;
}
::v-deep .el-table__body-wrapper {
  overflow: scroll;
}
::v-deep .subject_search .subject div {
  font-weight: normal;
}
::v-deep .subject_search .active_subject {
  font-weight: bold !important;
  color: #333 !important;
}
::v-deep .activeItem {
  font-weight: 800;
}
::v-deep .el-table__append-wrapper {
  position: fixed;
  bottom: 0%;
}
::v-deep .tabs {
  font-weight: normal !important;
}
::v-deep .highlight-row {
  color: var(--Brand-Color_6default, #2196F3);
}
::v-deep .el-table th {
  color: #333;
}
/* 字体颜色 */
.main {
  overflow: hidden;
  display: flex;

  .list_wrap1 {
    background: #ffffff;
    margin-top: 14rem;
    height: 558rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    ::v-deep .el-table{
      flex: none;
    }
    // padding-left: 20rem;
    .head_img {
      display: flex;
      justify-content: center;
      img {
        width: 44rem;
        height: 44rem;
        border-radius: 50%;
      }
    }
    .text2 {
      overflow: hidden;
      color: var(--light-999999, #999);
      text-overflow: ellipsis;

      font-size: 28px;
      font-style: normal;
      font-weight: 400;
      line-height: 42px; /* 150% */
    }
  }
  .list_wrap {
    background: #ffffff;
    margin-top: 14rem;
    height: 590rem;
    padding-left: 20rem;
    overflow: scroll;
    -ms-overflow-style: none;
    scrollbar-width: none;
    ::v-deep ::-webkit-scrollbar {
      display: none;
    }
    ::v-deep .el-table th {
      text-align: center;
    }
    .head_img {
      display: flex;
      justify-content: center;
      img {
        width: 44rem;
        height: 44rem;
        border-radius: 50%;
      }
    }
    .img_list {
      width: 1776px;
      height: 310px;
      flex-shrink: 0;
      display: flex;
      gap: 72rem;
      padding-top: 5rem;
      .head_img1 {
        position: absolute;
        top: 56%;
        left: 25%;
        flex-direction: column;
        align-items: center;
        transform: translate(-50%, -50%);
        width: 100%;
        display: flex;
        justify-content: center;
        img {
          width: 44rem;
          height: 44rem;
          border-radius: 50%;
        }
      }
      .head2 {
        position: absolute;
        top: 56%;
        width: 100%;
      }
      .head1 {
        position: absolute;
        top: 49%;
        // left: 50%;
        width: 100%;
      }
      .head3 {
        position: absolute;
        top: 54%;
        // left: 50%;
        width: 100%;
      }
      .head_img2 {
        flex-direction: column;
        align-items: center;
        // transform: translate(-50%, -50%);
        // width: 100%;
        display: flex;
        justify-content: center;
        img {
          width: 44rem;
          height: 44rem;
          border-radius: 50%;
        }
      }
      .head_img3 {
        position: absolute;
        top: 56%;
        left: 25%;
        flex-direction: column;
        align-items: center;
        // transform: translate(-50%, -50%);
        width: 100%;
        display: flex;
        justify-content: center;
        img {
          width: 44rem;
          height: 44rem;
          border-radius: 50%;
        }
      }
      .bottom {
        display: flex;
        // position: absolute;
        // top: 85%;
        // left: 50%;
        // transform: translate(-50%, -50%);
        width: 100%;
        justify-content: space-around;
        // gap: 213rem;
        .num {
          color: var(--light-999999, #999);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
        .num1 {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 150% */
        }
      }
      .text3 {
        display: flex;
        position: absolute;
        top: 65%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        justify-content: center;
        color: var(--light-999999, #999);
        font-size: 24rem;
      }
      .text1 {
        display: flex;
        position: absolute;
        top: 65%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        justify-content: center;
        color: var(--light-999999, #999);
        font-size: 24rem;
      }
      .text2 {
        display: flex;
        position: absolute;
        top: 70%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        justify-content: center;
        color: var(--light-999999, #999);
        font-size: 24rem;
      }
      .bottom2 {
        display: flex;
        // position: absolute;
        // top: 85%;
        // left: 50%;
        // transform: translate(-50%, -50%);
        width: 100%;
        justify-content: space-around;
        // gap: 213rem;
        .num {
          color: var(--light-999999, #999);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
        .num1 {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 150% */
        }
      }
      .bottom1 {
        display: flex;
        // position: absolute;
        // top: 75%;
        // left: 52%;
        // transform: translate(-50%, -50%);
        width: 100%;
        justify-content: space-around;
        // gap: 213rem;
        .num {
          color: var(--light-999999, #999);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
        .num1 {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 600;
          line-height: 36px; /* 150% */
        }
      }
      .top3 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // transform: translate(-50%, -50%);
        // width: 100%;
        .name {
          color: var(--light-333333, #333);

          font-size: 28rem;
          font-style: normal;
          font-weight: 600;
        }
        .school {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
      }
      .top2 {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // transform: translate(-50%, -50%);
        // width: 100%;
        .name {
          color: var(--light-333333, #333);

          font-size: 28rem;
          font-style: normal;
          font-weight: 600;
        }
        .school {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
      }
      .top1 {
        // position: absolute;
        // top: 56%;
        // left: 55%;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        // transform: translate(-50%, -50%);
        // width: 100%;
        .name {
          color: var(--light-333333, #333);

          font-size: 28rem;
          font-style: normal;
          font-weight: 600;
        }
        .school {
          color: var(--light-333333, #333);
          font-size: 24rem;
          font-style: normal;
          font-weight: 400;
          line-height: 36px; /* 150% */
        }
      }
    }
  }
  .subject_wrap {
    width: 100%;
    ::v-deep .subject_search {
      border-bottom: 1px solid var(--light-eeeeee, #eee);
      background: transparent;
      box-shadow: none;
      margin-bottom: 14rem;
      .subject {
        div {
          margin: 0px 40rem;
        }
      }
    }
    .type_id {
      display: inline-block;
      margin-left: 1420rem;
      border: solid 1px #cccccc;
      background: #fff;
      overflow: hidden;
      border-radius: 30rem;
      ::v-deep .el-input--medium .el-input__inner {
        height: 44rem;
        line-height: 44rem;
        // border-radius: 30rem;
        font-size: 20rem;
        border: 0;
      }

      ::v-deep .el-input__icon {
        height: 44rem;
        line-height: 44rem;
      }
    }
  }
  .left {
    width: 100rem;
  }
  .right {
    width: 100%;
    background: #f6f6f6;

    .tabs {
      margin-top: 22rem;
      display: flex;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 18rem;
      .tab {
        cursor: pointer;
        width: 260rem;
        height: 54rem;
        background: #2196f3;
        border-radius: 30rem;
        color: #ffffff;
        font-size: 24rem;
        font-weight: 800;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    .list {
      width: 100%;
      max-height: calc(100vh - 60rem - 40rem);
      background: white;
      overflow-y: auto;
      -ms-overflow-style: none;
      overflow: -moz-scrollbars-none;
      &::-webkit-scrollbar {
        width: 0 !important;
      }
      // .el-row {
      //   height: 80rem;
      //   border-bottom: 1rem solid #f1f1f1;
      //   &:hover {
      //     background: rgba($color: #2196f3, $alpha: 0.1);
      //   }
      // }
      div {
        height: 80rem;
        line-height: 80rem;
      }
      .subject {
        font-size: 20rem;
        font-weight: 500;
        color: #333333;
        text-indent: 50rem;
      }
      .telname {
        font-weight: bold;
        color: #000000;
        font-size: 20rem;
      }
      .btn_wrap {
        display: flex;
        justify-content: flex-end;
        .btn {
          width: 120rem;
          height: 44rem;
          background: #2196f3;
          border-radius: 5rem;
          font-size: 20rem;
          font-weight: bold;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-right: 20rem;
          margin-top: 20rem;
          cursor: pointer;
          // &:nth-child(1) {
          //   background: #e6f0ff !important;
          //   color: #2196f3 !important;
          // }
        }
      }
    }
  }
}
</style>
